import { BsSearch } from 'react-icons/bs'
import { Container, Content, Overlay, SearchBar } from './styles'
import TextDropdown from '../../../../components/TextDropdown'
import { useEffect } from 'react'
import { useLockScroll } from '../../../../hooks/use-lock-scroll'
import useGetSummary from '../../hooks/use-get-summary'
import { TSummaryQuestion } from './types'
import { useWindowSize } from 'react-use'
import Question from '../Question'

interface IProps {
  isOpen: boolean
  onClose(): void

  questionBookId: string

  onQuestionClick?(question: TSummaryQuestion): void
  onQuestionDelete?(question: TSummaryQuestion): void
}

const QuestionsSummary = (props: IProps) => {
  const { lock, unlock } = useLockScroll()

  const { height } = useWindowSize()

  const { swr, setPage, search, setSearch, status, setStatus, reachedEnd, isEmpty } = useGetSummary(
    props.questionBookId
  )

  const stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation()

  const onQuestionDelete = (question: TSummaryQuestion) => {
    swr.mutate()

    if (props.onQuestionDelete) props.onQuestionDelete(question)
  }

  useEffect(() => {
    if (props.isOpen) {
      swr.mutate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isOpen])

  useEffect(() => {
    if (props.isOpen) {
      lock()
    } else {
      unlock()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isOpen])

  const shouldRenderSeeMore = !isEmpty && !reachedEnd

  if (!props.isOpen) return null

  return (
    <Overlay onClick={props.onClose}>
      <Container onClick={stopPropagation}>
        <Content $innerHeight={height}>
          <div className="header">
            <p className="title">Sumário de questões</p>
            <button className="close" onClick={props.onClose}>
              Fechar
            </button>
          </div>
          <div className="scrollable">
            <div className="filters">
              <SearchBar>
                <BsSearch />

                <input
                  type="text"
                  placeholder="Buscar questões"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </SearchBar>

              <div className="group">
                <p className="label">Filtrar por</p>
                <TextDropdown
                  options={[
                    { label: 'Resposta certa', value: 'right' },
                    { label: 'Resposta errada', value: 'wrong' },
                    { label: 'Pendentes', value: 'pending' },
                    { label: 'Todas', value: '' },
                  ]}
                  defaultValue=""
                  value={status}
                  onChange={(value) => setStatus(value as string)}
                  className="text-dropdown"
                />
              </div>
            </div>

            <div className="list">
              {swr.isLoading && (
                <div className="loading">
                  <div className="loading-block"></div>
                  <div className="loading-block"></div>
                  <div className="loading-block"></div>
                  <div className="loading-block"></div>
                </div>
              )}

              {swr.data.docs.map((doc, index) => (
                <Question
                  key={doc._id}
                  data={doc}
                  position={index + 1}
                  onDelete={onQuestionDelete}
                  onClick={props.onQuestionClick}
                />
              ))}

              {shouldRenderSeeMore && (
                <div className="footer">
                  <button
                    className="load-more"
                    onClick={() => setPage((page) => page + 1)}
                    disabled={swr.isLoading}
                  >
                    Ver mais
                  </button>
                </div>
              )}
            </div>
          </div>
        </Content>
      </Container>
    </Overlay>
  )
}

export default QuestionsSummary
